import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { HeroSlider } from '../components/HeroSlider';
import { PricingSection } from '../components/PricingSection';
import { LocationsSection } from '../components/LocationsSection';
import { AmenitiesSection } from '../components/AmenitiesSection';
import { WhyUsSection } from '../components/WhyUsSection';
import { ApplicationSteps } from '../components/ApplicationSteps';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';

const HomePage = () => {
  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <HeroSlider />
        <PricingSection />
        <LocationsSection />
        <AmenitiesSection />
        <WhyUsSection />
        <ApplicationSteps />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
